import { Routes, Route } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import Dashboard from "../admin/pages/Dashboard";
import Products from "../admin/pages/Products";
import AddProduct from "../admin/pages/AddProduct";
//import EditProduct from "../admin/pages/EditProduct";
//import Orders      from "../admin/pages/Orders";
import Users from "../admin/pages/Users";
import Orders from "../admin/pages/Orders";

export default function AdminRoutes() {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="products" element={<Products />} />
        <Route path="product/add" element={<AddProduct />} />
        <Route path="orders" element={<Orders/>}/>
        <Route path="users" element={<Users />} />


      </Route>
    </Routes>
  );
}